import { render, staticRenderFns } from "./SendEmailPopup.vue?vue&type=template&id=36c416ac&"
import script from "./SendEmailPopup.vue?vue&type=script&lang=js&"
export * from "./SendEmailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports